<template>
  <el-row class="article-management" :gutter="24" style="background: transparent; ">
    <div class="dish-search-bar">
      <label for="article-search">Buscar grupos o artículos</label>
      <el-input id="article-search" v-model="search" clearable prefix-icon="el-icon-search" placeholder="Nombre de grupo, artículo o descripción" />
      <p role="status">{{ visibleGroups.length }} {{ visibleGroups.length === 1 ? 'grupo' : 'grupos' }} · {{ visibleArticleCount }} {{ visibleArticleCount === 1 ? 'artículo' : 'artículos' }}</p>
    </div>
    <p v-if="!visibleGroups.length" class="dish-search-empty">No hay grupos o artículos que coincidan con la búsqueda.</p>
    <el-collapse v-model="expandedGroups" :accordion="!search.trim()">
      <el-row v-for="item in visibleGroups" :key="item.key" class="row-collapse-item">
        <el-collapse-item :name="item.key">
          <template slot="title">
            <span class="collapse-title">
              <img
                v-if="item.iconImage || iconos[item.icon]"
                style="width: 2.5vw; height: 2.5vw; margin: 1vw"
                :src="item.iconImage ? photoUrl(item.iconImage) : iconos[item.icon].url"
              />
              <span
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-weight: normal;
                  color: white;
                "
                >{{ item.group }}</span
              >
            </span>
          </template>
          <!--ITEMS-->
          <el-row style="padding-top: 1vw">
            <el-row v-for="plu in visibleArticles(item)" :key="plu.key" class="row-item">
              <!--PLU-->
              <el-col :span="6" class="row-article-name">
                <img v-if="plu.image" :src="photoUrl(plu.image)" class="article-photo-thumbnail" alt="" />
                <strong>{{ plu.name }}</strong>
              </el-col>
              <!--Alergeno-->
              <el-col
                :span="3"
                class="article-allergens"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: left;
                "
              >
                <span class="article-mobile-label">Alérgenos</span>
                <span v-for="key in plu.alergenos" :key="key">
                  <img
                    class="item-img"
                    v-if="alergenos[key]"
                    :src="alergenos[key].url"
                    :alt="alergenos[key].name" :title="alergenos[key].name"
                /></span>
                <span v-if="!plu.alergenos || !plu.alergenos.length" class="article-mobile-empty">Sin indicar</span>
              </el-col>
              <!--DESCRIPCION-->
              <el-col
                :span="9"
                class="justify-left article-description"
                style=" padding-left: 2vw; font-style: oblique; text-align: left; "
                ><span class="article-mobile-label">Descripción</span><span>{{ plu.descripcion }}</span><span v-if="!plu.descripcion" class="article-mobile-empty">Sin descripción</span></el-col
              >
              <!--PRECIO-->
              <el-col
                :span="2"
                class="border-col-articles article-price"
                style=""
                >{{ plu.price }} €</el-col
              >
              <!--EDIT ICONS-->
              <el-col :span="4" class="article-actions">
                <el-row class="icons-modify">
                  <!--ARROW UP-->
                  <el-col class="border-col-articles">
                    <el-button
                      style="
                        padding: 0vw;
                        border: none;

                        width: 100%;
                      "
                      v-on:click="moveUPPLU(item, plu)"
                     :aria-label="'Subir ' + plu.name">
                      <i
                        class="el-icon-arrow-up"
                        style=" color: black"
                      ></i>
                    </el-button>
                    <!--ARROW DOWN-->
                    <el-button
                      style="
                        padding: 0vw;
                        border: none;

                        width: 100%;
                        margin: 0px;
                      "
                      v-on:click="moveDOWNPLU(item, plu)"
                     :aria-label="'Bajar ' + plu.name">
                      <i
                        class="el-icon-arrow-down"
                        style=" color: black"
                      ></i>
                    </el-button>
                  </el-col>
                  <!--ENABLE-->
                  <el-col class="border-col-articles">
                    <el-switch
                      v-model="plu.enable"
                      :aria-label="'Mostrar en carta: ' + plu.name"
                      @change="changeStatus()"
                    ></el-switch>
                  </el-col>
                  <!--MODIFY-->
                  <el-col class="border-col-articles">
                    <el-button
                      style="padding: 0vw; border: none; "
                      v-on:click="modifyPLU(item, plu)"
                     :aria-label="'Editar ' + plu.name">
                      <i
                        class="el-icon-edit"
                        style=" color: black"
                      ></i>
                    </el-button>
                  </el-col>
                  <!--DELETE-->
                  <el-col class="border-col-articles">
                    <el-button
                      style="padding: 0vw; border: none; "
                      v-on:click="selectPLUDelete(item, plu)"
                     :aria-label="'Eliminar ' + plu.name">
                      <i
                        class="el-icon-delete-solid"
                        style=" color: black"
                      ></i>
                    </el-button>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-row>
          <!--Nuevo PLU-->
          <el-row class="new-row-internal">
            <el-button
              v-on:click="selectPLUNew(item)"
              style="padding: 0vw; border: none; "
            >
              <i class="el-icon-plus" /> Añadir artículo
            </el-button>
          </el-row>
        </el-collapse-item>
      </el-row>
    </el-collapse>
    <!--DIALOGOS-->
    <el-row>
      <!--DIALOG EDIT-->
      <el-dialog
        title="Editar artículo"
        :visible.sync="dialogEdit"
        width="70%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-dialog
          width="30%"
          title="Añada el precio por favor"
          :visible.sync="notPrice"
          append-to-body
        ></el-dialog>
        <el-dialog
          width="30%"
          title="Añada el Nombre del artículo por favor"
          :visible.sync="notName"
          append-to-body
        ></el-dialog>
        <!--Nombre-->
        <span class="row-dialog-newPLU">
          <span class="management-field"><label for="articulos-field-0">Nombre</label><el-input
            placeholder="Nombre"
            v-model="name"
            maxlength="23"
            show-word-limit
           id="articulos-field-0"></el-input></span>
        </span>
        <!--Alergenos-->
        <span>
          <div
            style="

              color: black;
              text-align: left;
              margin-left: 3vw;
              margin-top: 2vh;
              margin-bottom: 2vh;
            "
          >
            Alérgenos
          </div>
          <div>
            <el-checkbox-group v-model="alergenosSeleccionados">
              <el-checkbox-button
                v-for="alergeno in alergenos" :aria-label="alergeno.name"
                :label="alergeno.key"
                :key="alergeno.key"
              >
                <img class="dialog-alergen" v-if="alergeno" :src="alergeno.url" :alt="alergeno.name" />
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </span>
        <!--Precio-->
        <span class="row-dialog-newPLU" style="margin-top: 2vw">
          <span class="management-field"><label for="articulos-field-1">Precio (€)</label><el-input
            placeholder="Precio"
            v-model="price"
           id="articulos-field-1"></el-input></span>
        </span>
        <!--Descripción-->
        <span class="row-dialog-newPLU">
          <span class="management-field"><label for="articulos-field-2">Descripción</label><el-input
            placeholder="Descripcion"
            type="textarea"
            v-model="descripcion"
            maxlength="120"
            show-word-limit
           id="articulos-field-2"></el-input></span>
        </span>
        <tariff-prices v-if="dialogEdit" :key="'tariff-edit-'+photoSession" v-model="prices" />
        <dish-photo-upload v-if="dialogEdit" :key="photoSession" ref="editPhoto" v-model="image" />
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="closeDialog()"
            :disabled="savingPhoto"
          >
            Cancelar
          </el-button>
          <el-button
            v-on:click="savePLU()"
            :loading="savingPhoto"
           type="primary">
            Guardar
          </el-button>
        </span>
      </el-dialog>
      <!--DIALOG DELETE-->
      <el-dialog
        title="Eliminar artículo"
        :visible.sync="dialogDelete"
        width="70%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        ¿Desea eliminar {{ name }}?
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="dialogDelete = false"
          >
            Cancelar
          </el-button>
          <el-button
            v-on:click="deletePLU()"
           type="danger">Eliminar</el-button>
        </span>
      </el-dialog>
      <!--DIALOG NEW-->
      <el-dialog
        title="Nuevo artículo"
        :visible.sync="dialogNew"
        width="70%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-dialog
          width="30%"
          title="Añada el precio por favor"
          :visible.sync="notPrice"
          append-to-body
        ></el-dialog>
        <el-dialog
          width="30%"
          title="Añada el nombre del articulo por favor"
          :visible.sync="notName"
          append-to-body
        ></el-dialog>
        <span class="row-dialog-newPLU">
          <span class="management-field"><label for="articulos-field-3">Nombre</label><el-input
            placeholder="Nombre"
            v-model="name"
            maxlength="23"
            show-word-limit
           id="articulos-field-3"></el-input></span>
        </span>
        <!--Alergenos-->
        <span>
          <div
            style="

              color: black;
              text-align: left;
              margin-left: 3vw;
              margin-top: 2vh;
              margin-bottom: 2vh;
            "
          >
            Alérgenos
          </div>
          <div>
            <el-checkbox-group v-model="alergenosSeleccionados">
              <el-checkbox-button
                v-for="alergeno in alergenos" :aria-label="alergeno.name"
                :label="alergeno.key"
                :key="alergeno.key"
              >
                <img class="dialog-alergen" v-if="alergeno" :src="alergeno.url" :alt="alergeno.name" />
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </span>
        <span class="row-dialog-newPLU" style="margin-top: 2vw">
          <span class="management-field"><label for="articulos-field-4">Precio (€)</label><el-input
            placeholder="Precio"
            v-model="price"
           id="articulos-field-4"></el-input></span>
        </span>
        <span class="row-dialog-newPLU">
          <span class="management-field"><label for="articulos-field-5">Descripción</label><el-input
            placeholder="Descripcion"
            type="textarea"
            v-model="descripcion"
            maxlength="120"
            show-word-limit
           id="articulos-field-5"></el-input></span>
        </span>
        <tariff-prices v-if="dialogNew" :key="'tariff-new-'+photoSession" v-model="prices" />
        <dish-photo-upload v-if="dialogNew" :key="photoSession" ref="newPhoto" v-model="image" />
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="closeDialog()"
          >
            Cancelar
          </el-button>
          <el-button
            v-on:click="savePLUNew()"
            :loading="savingPhoto"
           type="primary">
            Guardar
          </el-button>
        </span>
      </el-dialog>
    </el-row>
  </el-row>
</template>

<script>
import * as api from "../api/request.js";
import storage from "../api/storage.js";
import TariffPrices from '../components/TariffPrices.vue';
import DishPhotoUpload from "../components/DishPhotoUpload.vue";
import { prepareGroups } from "../utils/cartaEditing";
import { matchesSearch } from "../utils/menuDishes";
export default {
  components: { DishPhotoUpload, TariffPrices },
  data() {
    return {
      search: "",
      activeGroup: null,
      image: "",
      photoSession: 0,
      savingPhoto: false,
      version: undefined,
      savingCarta: false,
      pendingCartaSave: false,
      name: "",
      price: "",
      prices: [],
      descripcion: "",
      keyPLU: 0,
      keyGroup: 0,
      visible: false,
      dialogEdit: false,
      dialogNew: false,
      dialogDelete: false,
      notPrice: false,
      notName: false,
      alergenosSeleccionados: [],
      alergenos: [],
      iconos: [],
      alergen: [],
      data: [],
    };
  },
  mounted() {
    this.authenticated = storage.loadAuthenticated();
    if (this.authenticated === false || this.authenticated === null) {
      this.$router.replace({ name: "login" });
    } else {
      this.loadData();
    }
  },

  computed: {
    visibleGroups() { return this.search.trim() ? this.data.filter(group => matchesSearch({name:group.group},this.search) || this.visibleArticles(group).length) : this.data; },
    visibleArticleCount() { return this.visibleGroups.reduce((total,group)=>total+this.visibleArticles(group).length,0); },
    expandedGroups: {
      get() { return this.search.trim() ? this.visibleGroups.map(group=>group.key) : this.activeGroup; },
      set(value) { if(!this.search.trim())this.activeGroup=value; }
    },
    getData: function () {
      return this.data;
    },
  },
  methods: {
    visibleArticles(group) { return !this.search.trim() || matchesSearch({name:group.group},this.search) ? group.plu : group.plu.filter(article=>matchesSearch({name:article.name,description:article.descripcion},this.search)); },
    photoUrl: api.imageUrl,
    changeStatus: async function () {
      this.setData();
    },
    setData: async function () {
      if (this.savingCarta) { this.pendingCartaSave = true; return false; }
      this.savingCarta = true;
      try {
        do {
          this.pendingCartaSave = false;
          const result = await api.setCarta(JSON.parse(JSON.stringify(this.data)), this.version);
          this.version = result.version;
          if (!this.pendingCartaSave) this.data = result.carta;
        } while (this.pendingCartaSave);
        return true;
      } catch (error) {
        this.$message.error("No se han guardado los cambios. Recargando la carta.");
        await this.loadData();
        return false;
      } finally { this.savingCarta = false; this.pendingCartaSave = false; }
    },
    handleNodeClick(data) {
      console.log(data);
    },
    loadData: async function () {
      const snapshot = await api.getCartaCompleta();
      this.data = prepareGroups(snapshot.carta);
      this.version = snapshot.version;
      this.alergenos = await api.getAlergenos();
      this.iconos = await api.getIconos();
    },
    getIcon: function (icon) {
      if (icon == "") return require("../assets/grupos/undefined.png");
      return require("../assets/grupos/" + icon + ".png");
    },
    moveUPPLU: function (item, plu) {
      if (plu.key > 0) {
        const list = this.data[item.key].plu;
        const index = plu.key;
        const other = index + (-1);
        const copy = list[index];
        this.$set(list, index, list[other]);
        this.$set(list, other, copy);
        list.forEach((dish, key) => { dish.key = key; });
        this.setData();
      }
    },
    moveDOWNPLU: function (item, plu) {
      if (plu.key < item.plu.length - 1) {
        const list = this.data[item.key].plu;
        const index = plu.key;
        const other = index + (1);
        const copy = list[index];
        this.$set(list, index, list[other]);
        this.$set(list, other, copy);
        list.forEach((dish, key) => { dish.key = key; });
        this.setData();
      }
    },
    modifyPLU: function (group, plu) {
      this.image = plu.image || "";
      this.photoSession += 1;
      this.name = plu.name;
      this.price = plu.price;
      this.prices = (plu.prices || []).map(p=>({...p}));
      this.descripcion = plu.descripcion;
      this.alergenosSeleccionados = (plu.alergenos || []).slice();
      this.keyGroup = group.key;
      this.keyPLU = plu.key;
      this.dialogEdit = true;
    },
    savePLUNew: async function () {
      if (this.savingPhoto || this.savingCarta) return;
      if (!this.name.trim()) { this.notName = true; return; }
      if (this.price === "" || !Number.isFinite(Number(this.price))) { this.notPrice = true; return; }
      this.savingPhoto = true;
      try {
        const image = await this.$refs.newPhoto.upload();
        const group = this.data[this.keyGroup];
        const values = { name: this.name, price: Number(this.price).toFixed(2), descripcion: this.descripcion,
          alergenos: this.alergenosSeleccionados.slice(), prices:this.prices.map(p=>({...p})), image };
        group.plu.push({ ...values, key: group.plu.length, enable: true });
        if (await this.setData()) this.closeDialog();
      } catch (error) { this.$message.error("No se ha guardado el plato. Comprueba la imagen e inténtalo de nuevo."); }
      finally { this.savingPhoto = false; }
    },
    savePLU: async function () {
      if (this.savingPhoto || this.savingCarta) return;
      if (!this.name.trim()) { this.notName = true; return; }
      if (this.price === "" || !Number.isFinite(Number(this.price))) { this.notPrice = true; return; }
      this.savingPhoto = true;
      try {
        const image = await this.$refs.editPhoto.upload();
        const group = this.data[this.keyGroup];
        const values = { name: this.name, price: Number(this.price).toFixed(2), descripcion: this.descripcion,
          alergenos: this.alergenosSeleccionados.slice(), prices:this.prices.map(p=>({...p})), image };
        this.$set(group.plu, this.keyPLU, { ...group.plu[this.keyPLU], ...values });
        if (await this.setData()) this.closeDialog();
      } catch (error) { this.$message.error("No se ha guardado el plato. Comprueba la imagen e inténtalo de nuevo."); }
      finally { this.savingPhoto = false; }
    },
    deletePLU: function () {
      this.data[this.keyGroup].plu.splice(this.keyPLU, 1);
      //Actualizar las key
      var num = 0;
      this.data[this.keyGroup].plu.forEach((plu) => {
        plu.key = num;
        num++;
      });
      this.dialogDelete = false;
      this.setData();
    },
    selectPLUDelete: function (item, plu) {
      this.keyGroup = item.key;
      this.keyPLU = plu.key;
      this.name = plu.nombre;
      this.dialogDelete = true;
    },
    selectPLUNew: function (item) {
      this.keyGroup = item.key;
      this.name = "";
      this.price = "";
      this.prices = [];
      this.descripcion = "";
      this.alergenosSeleccionados = [];
      this.image = "";
      this.photoSession += 1;
      this.dialogNew = true;
    },
    closeDialog: function () {
      this.name = "";
      this.price = 0;
      this.descripcion = "";
      this.alergenosSeleccionados = [];
      this.dialogNew = false;
      this.dialogEdit = false;
    },
  },
};
</script>

<style scoped>
@media(min-width:761px){
.article-management .row-item{display:grid;grid-template-columns:minmax(0,1fr) minmax(90px,120px) minmax(0,1.25fr) 75px 200px;gap:14px;align-items:center}
.article-actions .icons-modify{display:grid;grid-template-columns:64px 44px 36px 36px;gap:6px}
.article-actions .icons-modify::before,.article-actions .icons-modify::after{display:none}
.article-actions .icons-modify > .el-col{width:auto;min-width:0;float:none}
.article-actions .icons-modify > .el-col:first-child{display:flex;gap:0}
.article-actions .icons-modify > .el-col:first-child .el-button{width:32px !important;min-width:32px;height:40px}
.article-management .row-item::before,.article-management .row-item::after{display:none}
.article-management .row-item > .el-col{width:auto !important;flex:none !important;float:none;padding:0 !important;min-width:0}
.article-management .row-item > .article-allergens{display:flex;flex-wrap:wrap;gap:6px;align-content:center}
.article-allergens .item-img{width:26px;height:26px;object-fit:contain;margin:0;display:block}
.article-allergens span{flex:0 0 26px}
}

.dish-search-bar { width:100%; box-sizing:border-box; margin:0 0 20px; padding:18px; background:white; border-radius:12px; text-align:left; }
.dish-search-bar label { display:block; font-size:15px; font-weight:600; color:#37474f; margin-bottom:10px; }
.dish-search-bar p { margin:10px 0 0; font-size:13px; color:#606b72; }
.dish-search-empty { padding:18px; background:white; border-radius:12px; color:#606b72; }
.article-photo-thumbnail { width: 44px; height: 36px; object-fit: cover; border-radius: 6px; margin-right: 8px; vertical-align: middle; }
.article-mobile-label, .article-mobile-empty { display: none; }
@media(max-width:760px) {
  .article-management .row-item { display:grid; grid-template-columns:minmax(0,1fr) auto; gap:12px; padding:18px 0; text-align:left; }
  .article-management .row-item::before, .article-management .row-item::after, .article-actions .icons-modify::before, .article-actions .icons-modify::after { display:none; }
  .article-management .row-item > .el-col { width:auto !important; float:none; flex:none !important; padding:0 !important; min-width:0; }
  .article-management .row-item > .row-article-name { grid-column:1; grid-row:1; gap:8px; font-size:14px; }
  .article-photo-thumbnail { flex-shrink:0; margin:0; }
  .article-management .row-item > .article-price { grid-column:2; grid-row:1; min-height:0; align-self:start; padding-top:2px !important; font-weight:700; color:#37474f; white-space:nowrap; }
  .article-management .row-item > .article-allergens, .article-management .row-item > .article-description { grid-column:1 / -1; display:block !important; font-size:14px; color:#687780; font-style:normal !important; }
  .article-mobile-label { display:block; margin-bottom:4px; font-size:12px; font-weight:700; color:#526f60; }
  .article-mobile-empty { display:block; color:#687780; }
  .article-allergens .item-img { width:26px; height:26px; margin:0 6px 0 0; vertical-align:middle; }
  .article-management .row-item > .article-actions { grid-column:1 / -1; border-top:1px solid #edf1ef; padding-top:8px !important; }
  .article-actions .icons-modify { display:grid; grid-template-columns:minmax(88px,1.4fr) repeat(3,minmax(44px,1fr)); gap:8px; }
  .article-actions .icons-modify > .el-col { width:auto; min-height:44px; float:none; }
  .article-actions .icons-modify > .el-col:first-child { display:flex; gap:4px; }
  .article-actions .icons-modify .el-button { width:44px !important; min-width:44px; min-height:44px; margin:0; }
}
</style>
